import _ from 'lodash';
import initialstate from '../../initialstate';
import {HttpStatusCodes, GALinkStatus, GAInstructionStatus, documentTypes} from '../../../util/uiconstants';
import {
	GET_ALL_COMPONENTS,
	POST_NEW_COMPONENT,
	SEND_LINK_REQUEST,
	PUT_COMPONENT,
	DELETE_COMPONENT,
	POST_SEND_INSTRUCTIONS,
	CREATE_ENTITY_FORM,
	CLEAN_COMPONENTS_AND_FORMACTIONS
} from '../../../actions/actiontypes';
import normalizeComponents, {mapComponent, normalizeDocument} from './normalizeComponents';

export default function groupComponentsReducer(state = initialstate.groupAudit, action) {
	switch (action.type) {
		case GET_ALL_COMPONENTS: {
			if (action?.responseObj?.status === HttpStatusCodes.Ok) {
				const parameters = {
					...state.components?.parameters
				};

				const serverSideResponse = action?.response?.value;
				if (serverSideResponse?.totalEntityCount) parameters.totalEntityCount = serverSideResponse.totalEntityCount;
				if (serverSideResponse?.pages) parameters.pages = serverSideResponse.pages;

				let unnormalizedComponents = action?.response;
				if (serverSideResponse?.data) unnormalizedComponents = serverSideResponse.data;

				if (action.isComponentV2) {
					return {
						...state,
						componentsV2: {
							data: normalizeComponents(unnormalizedComponents),
							parameters
						}
					};
				}

				return {
					...state,
					components: {
						data: normalizeComponents(unnormalizedComponents),
						parameters
					}
				};
			}

			return state;
		}
		case POST_NEW_COMPONENT: {
			if (action?.responseObj?.status === HttpStatusCodes.Created) {
				let normalizedData = normalizeComponents([action.response]);
				return {
					...state,
					components: {
						...state.components,
						data: _.orderBy([...(state.components?.data ?? []), ...normalizedData], ['shortName'], ['asc']),
						parameters: {
							...state.components?.parameters,
							totalEntityCount: state.components?.parameters?.totalEntityCount + 1
						}
					},
					componentsV2: {
						...state.componentsV2,
						data: _.orderBy([...(state.componentsV2?.data ?? []), ...normalizedData], ['shortName'], ['asc']),
						parameters: {
							...state.componentsV2?.parameters,
							totalEntityCount: state.componentsV2?.parameters?.totalEntityCount + 1
						}
					}
				};
			}
			return state;
		}
		case PUT_COMPONENT: {
			if (action?.responseObj?.status === HttpStatusCodes.Ok) {
				const getUpdatedData = (data) => {
					return data?.map((item) => {
						if (item.gaComponentId === action.payload.gaComponentId) {
							const mapped = mapComponent(action.response);
							return {...mapped, relatedDocuments: item.relatedDocuments};
						}
						return item;
					});
				};
				return {
					...state,
					components: {
						...state.components,
						data: getUpdatedData(state.components.data)
					},
					componentsV2: {
						...state.componentsV2,
						data: getUpdatedData(state.componentsV2.data)
					}
				};
			}
			return state;
		}
		case DELETE_COMPONENT: {
			if (action?.responseObj?.status === HttpStatusCodes.NoContent) {
				return {
					...state,
					components: {
						...state.components,
						data: state?.components?.data?.filter((item) => item.gaComponentId !== action.componentId),
						parameters: {
							...state.components?.parameters,
							totalEntityCount: state.components?.parameters?.totalEntityCount - 1
						}
					},
					componentsV2: {
						...state.componentsV2,
						data: state?.componentsV2?.data?.filter((item) => item.gaComponentId !== action.componentId),
						parameters: {
							...state.componentsV2?.parameters,
							totalEntityCount: state.componentsV2?.parameters?.totalEntityCount - 1
						}
					},
					referenceOnlyComponents: {
						...state.referenceOnlyComponents,
						data: state?.referenceOnlyComponents?.data?.filter((item) => item.id !== action.componentId),
						parameters: {
							...state.referenceOnlyComponents?.parameters,
							totalEntityCount:
								typeof state.referenceOnlyComponents?.parameters?.totalEntityCount === 'number'
									? state.referenceOnlyComponents?.parameters.totalEntityCount - 1
									: state.referenceOnlyComponents?.totalEntityCount
						}
					}
				};
			}
			return state;
		}
		case SEND_LINK_REQUEST: {
			if (action?.responseObj?.status === HttpStatusCodes.Created) {
				const componentsToUpdate = action?.GroupComponents?.map((x) => x.GroupComponentId);

				// Nothing to update.
				if (!componentsToUpdate || componentsToUpdate.length === 0) return state;

				const getUpdatedData = (data) => {
					return data?.map((x) => {
						if (componentsToUpdate.includes(x.gaComponentId)) {
							return {...x, linkRequest: GALinkStatus.Pending};
						}
						return x;
					});
				};
				return {
					...state,
					components: {
						data: getUpdatedData(state.components.data)
					},
					componentsV2: {
						data: getUpdatedData(state.components.data)
					}
				};
			}
			return state;
		}
		case POST_SEND_INSTRUCTIONS: {
			if (action?.responseObj?.status === HttpStatusCodes.Created) {
				const getUpdatedData = (data) => {
					return data?.map((item) => {
						if (item.gaComponentId === action.componentId) {
							return {
								...item,
								sentComponentSnapshotId: item.componentSnapshotId,
								sentScopeSnapshotId: item.snapshotId,
								sentStatusId: GAInstructionStatus.Queued
							};
						}
						return item;
					});
				};
				return {
					...state,
					components: {
						data: getUpdatedData(state.components.data)
					},
					componentsV2: {
						data: getUpdatedData(state.components.data)
					}
				};
			}
			return state;
		}
		case CREATE_ENTITY_FORM: {
			if (action?.responseObj?.status === HttpStatusCodes.Ok) {
				if (action.documentTypeId === documentTypes.groupInvolvementIndividualComponent) {
					const getUpdatedData = (data) => {
						return data?.map((item) => {
							const editedComponent = action.response.find((x) => x.entityObjectId === item.gaComponentId);
							if (!!editedComponent) {
								return {
									...item,
									relatedDocuments: [...item.relatedDocuments, normalizeDocument(editedComponent.document)]
								};
							}
							return item;
						});
					};
					return {
						...state,
						components: {
							...state.components,
							data: getUpdatedData(state.components.data)
						},
						componentsV2: {
							...state.componentsV2,
							data: getUpdatedData(state.componentsV2.data)
						}
					};
				}
			}
			return state;
		}
		case CLEAN_COMPONENTS_AND_FORMACTIONS:
			// Renders Group involvement summary table with up-to-date data.
			return {
				...state,
				components: {
					...initialstate.groupAudit.components
				},
				componentsV2: {
					...initialstate.groupAudit.componentsV2
				}
			};
		default:
			return state;
	}
}
